import { render } from "./SuccessfulModal.vue?vue&type=template&id=08ae9382&scoped=true"
import script from "./SuccessfulModal.vue?vue&type=script&lang=js"
export * from "./SuccessfulModal.vue?vue&type=script&lang=js"

import "./SuccessfulModal.vue?vue&type=style&index=0&id=08ae9382&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ae9382"]])

export default __exports__